<template>
  <b-sidebar
    v-model="toggle"
    width="50%"
    id="sidebar-right"
    title="Users"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template #default="{}">
      <div class="d-flex text-light align-items-center" style="background-color: #495057">
        <strong class="mr-auto ml-2">Add Group Cross Platform</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <!-- <form-wizard step-size="sm" color="#556ee6">
        <tab-content title="Users" icon="mdi mdi-account-circle"> -->
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            Mapping Between <b>{{ groupName }}</b> Group
          </h4>
          <br />
          <validationObserver ref="addGroupCrossPlatformForm" tag="form">
            <form @submit.prevent="addObj" class="form-horizontal">
              <div class="form-group row">
                <label class="col-form-label col-lg-3">Select Applications</label>
                <div class="col-lg-9">
                  <multiselect
                    v-model="applicationSelected"
                    label="display_name"
                    placeholder="Please select application"
                    :options="applications"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.display_name }}</strong>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-lg-3">Group Name</label>
                <div class="col-lg-9">
                  <multiselect
                    v-model="groupSelected"
                    label="display_name"
                    placeholder="Please select group"
                    :options="groups"
                    :disabled="!hasGroups"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.display_name }}</strong>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-10 text-right mt-9 color-red">
                  <label v-show="isNotFoundGroups">ไม่พบผลลัพธ์กลุ่มใดๆ</label>
                </div>
                <div class="col-sm-2 text-right">
                  <button @click="onAdd" type="button" class="btn btn-primary">
                    Add
                  </button>
                </div>
              </div>
            </form>
          </validationObserver>
          <hr />
          <div v-show="hasGroupsMapper" class="form-group row">
            <div class="col-lg-12">
              <label class="col-form-label">Data Mapping between groups</label>
            </div>
            <div class="col-lg-12">
              <table class="table">
                <thead>
                  <tr>
                    <th>Application</th>
                    <th>Group</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(groupMapper, index) in groupsMapper" :key="index">
                    <td>{{ groupMapper.application.display_name }}</td>
                    <td>{{ groupMapper.group.display_name }}</td>
                    <td class="text-right">
                      <button
                        @click="onDelete(index)"
                        type="button"
                        class="btn btn-danger"
                      >
                        <i class="mdi mdi-delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-12 text-center">
              <hr />
              <button
                @click="onConfirmSaveGroupCrossPlatform"
                type="button"
                class="btn btn-success"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import { eventBus } from "@/main.js";

import { userComputed, userMethods, applicationComputed } from "@/state/helpers";
import applicationService from "@/helpers/service/application-provider";
import groupService from "@/helpers/service/group-provider";

export default {
  components: {},
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: "",
    },
    groupName: {
      type: String,
      default: "",
    },
    applicationGroupCrossPlatform: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggle: false,
      applications: [],
      applicationSelected: null,
      groups: [],
      groupSelected: null,
      isNotFoundGroups: false,
      groupsMapper: [],
    };
  },
  computed: {
    ...userComputed,
    ...applicationComputed,
    isApplicationSelected() {
      return this.$validate.isObjectKeyValid(this.applicationSelected, "id");
    },
    hasGroups() {
      return this.$validate.anyArrayObjectValid(this.groups);
    },
    isGroupSelected() {
      return this.$validate.isObjectKeyValid(this.groupSelected, "id");
    },
    hasGroupsMapper() {
      return this.$validate.anyArrayObjectValid(this.groupsMapper);
    },
  },
  watch: {
    toggleSideBar: async function (val) {
      this.toggle = val;
      if (!val) {
        this.isClearAll();
      } else {
        await this.onGetApplications();
      }
    },
    applicationSelected: {
      handler: async function () {
        this.groups = [];
        this.groupSelected = null;
        this.isNotFoundGroups = false;
        if (!this.isApplicationSelected) {
          return;
        }
        await this.onGetGroups();
      },
      deep: true,
    },
  },
  methods: {
    async onGetApplications() {
      this.applications = [];

      let params = new URLSearchParams();
      params.append("pageSize", 9999);
      params.append("status", "Active");

      let result = await applicationService.getApplicationsAsync(params);
      if (result.status === 200) {
        this.applications = result.data.items;
        if (this.$validate.isObjectKeyValid(this.GET_APPLICATION_SELECTED, "id")) {
          this.applications = this.applications.filter(
            (item) => item.id !== this.GET_APPLICATION_SELECTED.id
          );
        }

        this.isLoading = false;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onGetGroups() {
      if (!this.isApplicationSelected) {
        return;
      }

      this.isClearGroup();

      let params = new URLSearchParams();
      params.append("pageSize", 9999);
      params.append("status", "Active");

      let result = await groupService.getGroupsAsync(this.applicationSelected.id, params);
      if (
        result.status === 200 &&
        this.$validate.anyPagingArrayObjectValid(result.data)
      ) {
        const existingGroupIds = this.applicationGroupCrossPlatform.flatMap((q) =>
          q.groups.map((groupSelected) => groupSelected.group_id)
        );
        const mapGroupIds = this.groupsMapper.map((q) => q.group.id);
        existingGroupIds.push(...mapGroupIds);
        this.groups = result.data.items.filter(
          (group) => !existingGroupIds.includes(group.id)
        );

        if (this.groups.length === 0) {
          this.isNotFoundGroups = true;
        }
      } else if (
        result.status === 404 ||
        (result.status === 200 && !this.$validate.anyPagingArrayObjectValid(result.data))
      ) {
        this.isNotFoundGroups = true;
      } else {
        eventBus.$emit("error-modal", result.data.message);
      }
    },
    async onAdd() {
      if (!this.isApplicationSelected) {
        eventBus.$emit("error-modal", "Please select application");
        return;
      }
      if (!this.isGroupSelected) {
        eventBus.$emit("error-modal", "Please select group");
        return;
      }
      let isExist = this.groupsMapper.some(
        (item) => item.group.id === this.groupSelected.id
      );
      if (isExist) {
        eventBus.$emit("error-modal", "Group already exists");
        return;
      }
      this.groupsMapper.push({
        application: {
          id: this.applicationSelected.id,
          display_name: this.applicationSelected.display_name,
        },
        group: {
          id: this.groupSelected.id,
          display_name: this.groupSelected.display_name,
        },
      });

      this.isClearApplicationSelected();
    },
    async onDelete(index) {
      this.groupsMapper.splice(index, 1);
      await this.onGetGroups();
    },
    isClearApplicationSelected() {
      this.applicationSelected = null;
      this.isClearGroup();
    },
    isClearGroup() {
      this.groups = [];
      this.groupSelected = null;
      this.isNotFoundGroups = false;
    },
    isClearAll() {
      this.applications = [];
      this.isClearApplicationSelected();
      this.groupsMapper = [];
    },
    async onConfirmSaveGroupCrossPlatform() {
      if (!this.hasGroupsMapper) {
        eventBus.$emit("error-modal", "Please add groups");
        return;
      }

      this.$utils
        .confirmAlertDisplay(
          `Warning role change is dangerous!!!`,
          `Are you sure you want to change the group cross platform?`
        )
        .then(async (result) => {
          if (result) {
            await this.onSubmit();
          }
        });
    },
    async onSubmit() {
      let body = await this.groupApplicationSelected();
      console.log("body", body);

      let result = await groupService.createGroupCrossPlatformAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.groupId,
        body
      );
      if (result.status === 201) {
        eventBus.$emit("info-modal", "Add group cross platform success");
        this.$emit("hidden");
      } else {
        eventBus.$emit("error-modal", result.data.message);
      }
    },
    async groupApplicationSelected() {
      const acc = new Map();
      for (const groupMapper of this.groupsMapper) {
        const applicationId = groupMapper.application.id;
        if (!acc.has(applicationId)) {
          acc.set(applicationId, []);
        }
        acc.get(applicationId).push(groupMapper.group.id);
      }
      const applications = Array.from(acc, ([application_id, group_ids]) => ({
        application_id,
        group_ids,
      }));
      return { applications };
    },
  },
};
</script>
<style scope>
.vue-form-wizard .wizard-tab-content {
  padding: 0 0 5px;
}
.disabled > i,
.disabled > span {
  color: #9a9393;
}
.stepTitle {
  color: #556ee6;
}
.mt-9 {
  margin-top: 9px;
}
.color-red {
  color: red;
}
.btn > i {
  margin-right: 0px !important;
}
</style>
